import { render } from "./Privacy.vue?vue&type=template&id=55bd8b5b&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=55bd8b5b&scoped=true&lang=scss"

import exportComponent from "/var/www/lembergflowers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bd8b5b"]])

export default __exports__